import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./lib/auth";
import { ThemeProvider, useTheme } from "./lib/theme";

import AppShell from "./components/layout/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import RouteDetail from "./pages/RouteDetail";
import Alerts from "./pages/Alerts";
import DataSources from "./pages/DataSources";
import Overrides from "./pages/Overrides";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm" style={{ color: "var(--text-secondary)" }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster richColors theme={theme} position="top-right" />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/routes/:id" element={<RouteDetail />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/data-sources" element={<DataSources />} />
              <Route path="/overrides" element={<Protected roles={["admin"]}><Overrides /></Protected>} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/settings" element={<Protected roles={["admin"]}><Settings /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <ThemedToaster />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
